import React from 'react';
import { Icon } from './Icon.js';
export const IconChartLine2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M1.75,13c-.192,0-.384-.073-.53-.22-.293-.293-.293-.768,0-1.061L6.116,6.823c.487-.487,1.28-.487,1.768,0l3.116,3.116,4.72-4.72c.293-.293,.768-.293,1.061,0s.293,.768,0,1.061l-4.896,4.896c-.487,.487-1.28,.487-1.768,0l-3.116-3.116L2.28,12.78c-.146,.146-.338,.22-.53,.22Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconChartLine2Fill18.js.map